export class Versions {
    constructor() {}

    public assortmentExcel: string = '1.3.0';
    public changeBufferExcel: string = '1.3.0';
    public bufferTableExcel: string = '1.4.4';
    public marketingPurchase: string = '1.3.2';
    public orders: string = '1.4.11';
    public stocks: string = '1.2.18';
    public itemProperties: string = '1.5.8';
    public chart: string = '1.0.4';
    public supplySchedules: string = '0.4.15';
    public stocksPresetEditor: string = '1.0.0';
    public vacation: string = '1.0.1';
    public manualOrders: string = '1.2.3';
}



// WEBPACK FOOTER //
// ./src/app/shared/models/vesions.ts